<div class="footer">
  <div class="data breakpoint-wrapper">
    <div class="contact-info">
      <ul class="links">
        <li class="link-item"><a href="https://aidwatch.ch/auskunft#vg-form-contact" target="_blank" class="link">Kontakt</a></li>
        <li class="link-item"><a href="https://aidwatch.ch/agb/" target="_blank" class="link">AGB</a></li>
        <li class="link-item"><a href="https://aidwatch.ch/impressum/" target="_blank" class="link">Impressum</a></li>
      </ul>
      <div class="text-info">
        <span class="text-item company">NESTOR Intl. Corp. AG</span>
        <span class="text-item adress">Sandgrube 29</span>
        <span class="text-item region">CH-9050 Appenzell</span>
      </div>
    </div>
    <div class="payment-info">
      <span class="payment-text">
        Sie können per Rechnung oder folgenden Kreditkarten bezahlen:
      </span>
      <img src="./assets/footer/visa.svg" alt="visa-logo" class="card visa">
      <img src="./assets/footer/mastercard.svg" alt="mastercard-logo" class="card master">
    </div>
  </div>
</div>
